import React, { Component } from 'react'
import classnames from 'classnames'

class SectionWrapper extends Component {
  componentDidMount = () => {
    const options = { passive: false } // force application to get exact heights at event
    const { index, referenceKey, announceHeight } = this.props
    if (this.node) {
      let _node = this.node
      let callback = () =>
        announceHeight(referenceKey, index, _node.clientHeight, _node.offsetTop)
      window.addEventListener('resize', callback, options)
      callback()
      setTimeout(callback, 100)
    }
  }

  componentWillUnmount = () => {
    const { announceHeight } = this.props
    window.removeEventListener('resize', announceHeight)
  }

  render() {
    const { referenceKey } = this.props
    const colorStyle = classnames({
      'section-shadow': this.props.shadow === true,
      'section-light':
        this.props.color === 'LIGHT' || this.props.color === 'TRANSPARENT',
      'section-dark': this.props.color === 'DARK'
    })
    return (
      <div
        id={`heightWrapper-${referenceKey}`}
        className={`heightWrapper ${colorStyle}`}
        ref={node => (this.node = node)}
      >
        {this.props.child}
      </div>
    )
  }
}

export default SectionWrapper



// WEBPACK FOOTER //
// ./src/Components/SectionWrapper.js